export default __webpack_public_path__ + "static/media/blog-oil-stain-003.618fe74f.jpg";